import { makeAutoObservable, observable, toJS  } from "mobx";

import { CommercialService } from "../services/commercialService";
import moment from "moment";
import { getCurrentUser } from "../../../Utility/modules/helpers";
class CommercialStoreStore {
  constructor() {
    makeAutoObservable(this);
  }

  contractCenters = observable.map({});
  contractObligations = observable.map({});
  disableSave = true;
  showRolloverDialog = false;
  isLoading = false;
  isSubmitting = false;
  isCopying = false;
  selRow = {};
  rolloverYear = moment().year() - 1;
  contractYear = moment(new Date()).format("YYYY");
  async createContract(contract) {
    try {
      this.isSubmitting = true;
      const c = await CommercialService.createContract(contract);
      this.contractCenters.set(c.contractId, c);
      this.isSubmitting = false;
      return c;
    } catch (error) {
      throw error;
    }
  }

  async loadContracts() {
    try {
      this.isLoading = true;
      const retVal = await CommercialService.getAllContracts();
      this.contractCenters.clear();
      retVal.forEach((c) => this.contractCenters.set(c.contractId, c));
      this.isLoading = false;
    } catch (error) {
      throw error;
    }
  }
  async loadContractObligations(year, assetId) {
    try {
      this.isLoading = true;
      this.contractObligations.clear();
      const retVal = await CommercialService.getContractObligations(
        year,
        assetId
      );
      console.log("obligations", retVal);
      retVal.forEach((co) => {
        this.contractObligations.set(co.contractObligationId, co);
      });
      this.isLoading = false;
    } catch (error) {
      throw error;
    }
  }
  async rollover(year, assetId) {
    try {
      await this.loadContracts();

      this.contractObligations.clear();
      let idx = 0;
      this.contractCenters.forEach((cc) => {
        idx++;
        let co = {
          phantomId: `#${idx}`,
          contractCenter: cc.contractCenter,
          unit: cc.unit,
          assetId: assetId,
          year: year,
          obligation: 0,
          contractId: cc.contractId,
        };
        this.contractObligations.set(co.phantomId, co);
      });
      console.log("rolover", [...this.contractObligations.values()]);
    } catch (error) {
      throw error;
    }
  }
  async save() {
    try {
      this.isSubmitting = true;
      const obligations = [...this.contractObligations.values()].map((c) =>
        toJS({ ...c, uploadedBy: getCurrentUser().fullName })
      );
      const retVal = await CommercialService.save(obligations);
      this.contractObligations.clear();
      retVal.forEach((o) => {
        this.contractObligations.set(o.contractObligationId, o);
      });
    } catch (error) {
      throw error;
    } finally {
      this.isSubmitting = false;
      this.disableSave = true;
    }
  }

  async copy(assetId) {
    this.isCopying = true;

    try {
      const retVal = await CommercialService.copy(this.rolloverYear, assetId);
      this.contractObligations.clear();
      retVal.forEach((o) => {
        this.contractObligations.set(o.contractObligationId, {
          ...o,
          contractObligationId: 0,
          uploadedBy: "",
          year: this.contractYear,
          uploadedOn: moment(),
        });
      });
    } catch (error) {
      throw error;
    } finally {
      this.isCopying = false;
    }
  }
}


const contractObligationStore = new CommercialStoreStore();
export default contractObligationStore;

